import { backendUrl } from '@shared/constants/urls/appUrls';
import { fetchWithAuth } from '@shared/utils/auth';

//------------------------------------------------------------------------------
//               Отправить запрос на получение похожих постов
//------------------------------------------------------------------------------
export const getSimilarPosts = async ({ object_id, content_type }) => {
  const url = `${backendUrl}/api/alpha/similar-posts/?object_id=${object_id}&content_type_id=${content_type}`;
  const options = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  };
  try{
    const response = await fetchWithAuth(url, options);
    if (!response.ok) {
      throw new Error(`Сетевая ошибка при получении похожих постов: HTTP error! Status: ${ response.status }`);
    }
    return await response.json();
  } catch(error){
    console.error('Программная ошибка получения похожих постов:', error);
    throw error;
  }
};
//xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx